var map = {
	"./da-DK": [
		864,
		0,
		8
	],
	"./da-DK.ts": [
		864,
		0,
		8
	],
	"./de-DE": [
		865,
		0,
		9
	],
	"./de-DE.ts": [
		865,
		0,
		9
	],
	"./en-AU": [
		866,
		0,
		10
	],
	"./en-AU.ts": [
		866,
		0,
		10
	],
	"./en-GB": [
		867,
		0,
		11
	],
	"./en-GB.ts": [
		867,
		0,
		11
	],
	"./en-US": [
		868,
		0,
		12
	],
	"./en-US.ts": [
		868,
		0,
		12
	],
	"./es-ES": [
		869,
		0,
		13
	],
	"./es-ES.ts": [
		869,
		0,
		13
	],
	"./fr-FR": [
		870,
		0,
		14
	],
	"./fr-FR.ts": [
		870,
		0,
		14
	],
	"./it-IT": [
		871,
		0,
		15
	],
	"./it-IT.ts": [
		871,
		0,
		15
	],
	"./nb-NO": [
		872,
		0,
		16
	],
	"./nb-NO.ts": [
		872,
		0,
		16
	],
	"./nl-NL": [
		873,
		0,
		17
	],
	"./nl-NL.ts": [
		873,
		0,
		17
	],
	"./pl-PL": [
		874,
		0,
		18
	],
	"./pl-PL.ts": [
		874,
		0,
		18
	],
	"./pt-PT": [
		875,
		0,
		19
	],
	"./pt-PT.ts": [
		875,
		0,
		19
	],
	"./sv-SE": [
		876,
		0,
		20
	],
	"./sv-SE.ts": [
		876,
		0,
		20
	],
	"./tr-TR": [
		877,
		0,
		21
	],
	"./tr-TR.ts": [
		877,
		0,
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1839;
module.exports = webpackAsyncContext;